import React from 'react'
import {Container, Row, Col} from '@bootstrap-styled/v4'
import {StaticQuery, graphql} from 'gatsby'
import {Element} from 'react-scroll'
import WOW from 'react-wow';

import * as S from './styled'

const BannerDetalhes = () => {
    return (
        <StaticQuery
            query={graphql `
                query { 
                    mobileHero: file(relativePath: {
                        eq: "trumps/mobile-hero.png"}){
                            childImageSharp {
                                fluid(maxWidth: 1400){ ...GatsbyImageSharpFluid }
                            }
                    }

                    content: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(section_detalhes)/"}}) {
                        nodes {
                            frontmatter {
                                title
                                title2
                                subtitle
                                description
                            }
                        }
                    }
                }`}
            render={data => (
            <Element name="section-BannerDetalhes">
                <S.BannerDetalhesWrapper>
                    <S.BannerDetalhesContent>
                        <Container>
                            <Row>
                                <WOW animation="fadeIn">
                                    <Col
                                        xs={{
                                        order: 2,
                                        size: 12
                                    }}
                                        lg={{
                                        size: 6,
                                        order: 1
                                    }}>
                                        <S.BannerDetalhesHero fluid={data.mobileHero.childImageSharp.fluid}></S.BannerDetalhesHero>
                                    </Col>
                                </WOW>
                                <Col
                                    xs={{
                                    order: 1,
                                    size: 12
                                }}
                                    lg={{
                                    size: 6,
                                    order: 2
                                }}>
                                    <S.BannerDetalhesCaption>
                                        <WOW animation="fadeInUp">
                                            <S.BannerDetalhesSubTitle>
                                                {data.content.nodes[0].frontmatter.subtitle}
                                            </S.BannerDetalhesSubTitle>
                                            <S.BannerDetalhesTitle>
                                                {data.content.nodes[0].frontmatter.title}
                                                <br/>
                                                <span> {data.content.nodes[0].frontmatter.title2}</span>
                                            </S.BannerDetalhesTitle>
                                            <S.BannerDetalhesDesc>
                                            {data.content.nodes[0].frontmatter.description}
                                            </S.BannerDetalhesDesc>
                                        </WOW>
                                    </S.BannerDetalhesCaption>
                                </Col>
                            </Row>
                        </Container>
                    </S.BannerDetalhesContent>
                </S.BannerDetalhesWrapper>
            </Element>
        )}/>
    )
}

export default BannerDetalhes